/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsDimensions, FxIdDomainSettingsDimensionsFromJSONTyped, FxIdDomainSettingsDimensionsToJSON, } from './FxIdDomainSettingsDimensions';
export function FxIdDomainSettingsPresentationOptionsMaxSizeFromJSON(json) {
    return FxIdDomainSettingsPresentationOptionsMaxSizeFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPresentationOptionsMaxSizeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsDimensions(json)) {
        return FxIdDomainSettingsDimensionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPresentationOptionsMaxSizeToJSON(json) {
    return FxIdDomainSettingsPresentationOptionsMaxSizeToJSONTyped(json, false);
}
export function FxIdDomainSettingsPresentationOptionsMaxSizeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsDimensions(value)) {
        return FxIdDomainSettingsDimensionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPresentationOptionsMaxSize.js.map